/* tslint:disable */
/* eslint-disable */
/**
 * UniCatDB API
 * UniCatDB application API documentation, with examples and live testing.  This API is built in accordance with the **JSON API 1.0 standard**. For general information, see [the documentation](http://jsonapi.org/format/).  -  JSON API standard requires use of the JSON API media type (application/vnd.api+json) for exchanging data. Clients must send all JSON API data with the headers `Content-Type: application/vnd.api+json` (POST, PATCH) and `Accept: application/vnd.api+json` (GET, DELETE). - [Relationships](http://jsonapi.org/format/#fetching-relationships) and their [inclusions](http://jsonapi.org/format/#fetching-includes) via the `include` query parameter, as specified by the standard, **are not implemented**, since there are no relationships present in the data model. - The standard does not prescribe any filtering strategies. This API implements two strategies which can be combined: **Basic filtering** based on the used [JSON API library](https://json-api-dotnet.github.io/#/filtering) and **Custom filtering** which allow for any possible query to the MongoDB server and can be extended and customize in the future. For more information about filtering, see the description of the `filter` down bellow. - **Non-standard PATCH behavior:** Sucessfull PATCH reuest always result in HTTP 200 response with the updated resource object, even if the server does not perform any additional modifications. HTTP 204 is never used in PATCH responses.  Attachment upload endpoint uses the **TUS protocol**. See [the documentation](https://tus.io/). When integrating, it is recommended to use one of the [official TUS client implementations](https://tus.io/implementations.html).  - **Supported TUS versions**:   -  1.0.0 - **Supported TUS extensions**:   - Creation   - Creation Defer Length   - Creation With Upload   - Checksum   - Checksum Trailer - **Required metadata**:   - `fileName` - name of the original file incl. file extension   - `contentType`- the MIME type of the file 
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LatLngGps,
    LatLngGpsFromJSON,
    LatLngGpsFromJSONTyped,
    LatLngGpsToJSON,
    TaxonomyName,
    TaxonomyNameFromJSON,
    TaxonomyNameFromJSONTyped,
    TaxonomyNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface Finding
 */
export interface Finding {
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    owner?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Finding
     */
    permissions?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    documentName?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof Finding
     */
    dynamicData?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    documentSet?: string;
    /**
     * 
     * @type {number}
     * @memberof Finding
     */
    amount?: number;
    /**
     * ISO 8601 formatted date, UTC time of day component may be present and equals to zero (00:00:00.000Z)
     * @type {Date}
     * @memberof Finding
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    person?: string;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    locationDescription?: string;
    /**
     * 
     * @type {LatLngGps}
     * @memberof Finding
     */
    locationGpsPoint?: LatLngGps | null;
    /**
     * Well-known text (WKT) representation of location geometry (ISO/IEC 13249-3:2016 standard)
     * @type {string}
     * @memberof Finding
     */
    readonly locationGpsPointWkt?: string | null;
    /**
     * 
     * @type {Array<LatLngGps>}
     * @memberof Finding
     */
    locationGpsArea?: Array<LatLngGps>;
    /**
     * Well-known text (WKT) representation of location geometry (ISO/IEC 13249-3:2016 standard)
     * @type {string}
     * @memberof Finding
     */
    readonly locationGpsAreaWkt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    note?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Finding
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    readonly taxonomyHierarchyId?: string;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    taxonomyHumanReadable?: string;
    /**
     * 
     * @type {TaxonomyName}
     * @memberof Finding
     */
    taxonomyName?: TaxonomyName;
    /**
     * 
     * @type {string}
     * @memberof Finding
     */
    attachmentNote?: string;
}

export function FindingFromJSON(json: any): Finding {
    return FindingFromJSONTyped(json, false);
}

export function FindingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Finding {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
        'documentName': !exists(json, 'documentName') ? undefined : json['documentName'],
        'dynamicData': !exists(json, 'dynamicData') ? undefined : json['dynamicData'],
        'documentSet': !exists(json, 'documentSet') ? undefined : json['documentSet'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'person': !exists(json, 'person') ? undefined : json['person'],
        'locationDescription': !exists(json, 'locationDescription') ? undefined : json['locationDescription'],
        'locationGpsPoint': !exists(json, 'locationGpsPoint') ? undefined : LatLngGpsFromJSON(json['locationGpsPoint']),
        'locationGpsPointWkt': !exists(json, 'locationGpsPointWkt') ? undefined : json['locationGpsPointWkt'],
        'locationGpsArea': !exists(json, 'locationGpsArea') ? undefined : ((json['locationGpsArea'] as Array<any>).map(LatLngGpsFromJSON)),
        'locationGpsAreaWkt': !exists(json, 'locationGpsAreaWkt') ? undefined : json['locationGpsAreaWkt'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'taxonomyHierarchyId': !exists(json, 'taxonomyHierarchyId') ? undefined : json['taxonomyHierarchyId'],
        'taxonomyHumanReadable': !exists(json, 'taxonomyHumanReadable') ? undefined : json['taxonomyHumanReadable'],
        'taxonomyName': !exists(json, 'taxonomyName') ? undefined : TaxonomyNameFromJSON(json['taxonomyName']),
        'attachmentNote': !exists(json, 'attachmentNote') ? undefined : json['attachmentNote'],
    };
}

export function FindingToJSON(value?: Finding | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'owner': value.owner,
        'permissions': value.permissions,
        'documentName': value.documentName,
        'dynamicData': value.dynamicData,
        'documentSet': value.documentSet,
        'amount': value.amount,
        'date': value.date === undefined ? undefined : (value.date.toISOString().substr(0,10)),
        'person': value.person,
        'locationDescription': value.locationDescription,
        'locationGpsPoint': LatLngGpsToJSON(value.locationGpsPoint),
        'locationGpsArea': value.locationGpsArea === undefined ? undefined : ((value.locationGpsArea as Array<any>).map(LatLngGpsToJSON)),
        'note': value.note,
        'tags': value.tags,
        'taxonomyHumanReadable': value.taxonomyHumanReadable,
        'taxonomyName': TaxonomyNameToJSON(value.taxonomyName),
        'attachmentNote': value.attachmentNote,
    };
}


